<template>
    <a @click="onClick">
        <div class="title-info" style="margin-left: 2px">
            <div style="margin-top: -2px" v-if="next">
                <span>nächster ZÜS Termin: </span>
                <span :class="nextOutdated?'outdated error-background':''">{{ next }}</span>
            </div>
            <div style="margin-top: -2px;" v-if="last">Letzte Prüfung: {{ last }}</div>
        </div>
    </a>
</template>

<script>

import moment from "moment";
import Core       from "@/modules/core/service/Core";
import Assessment from "@/modules/inc/assessments/service/Assessment";

export default {
    name: "CSiteTitleRowAssessment",

    components: {
    },

    props: {
        site: {
            required: true,
            type    : Object
        }
    },

    data: () => ({
        items   : null,
        menuOpen: false,
        expand  : false
    }),

    watch: {
        site: function () {
            this.load();
        }
    },

    mounted() {
        const self = this;
        this.load();
        this.$root.$off("assessment-plan");
        this.$root.$on("assessment-plan", () => {
            self.load();
        })
    },

    computed: {
        last () {
            if (this.items === null || this.items.length === 0) {
                return "---"
            }

            const entry = this.items.find(entry => entry.status.terminated && entry.dateAssessment);
            if (entry) {
                return this.format(entry.dateAssessment);
            }

            return "---"
        },

        nextDate () {
            if (this.items === null || this.items.length === 0) {
                return null
            }

            const now = Core.format.date.today();
            const entries = this.items.filter (entry => entry.dateAssessment >= now || entry.dateNextAssessment >= now);
            if (entries.length > 0) {
                const entry = entries[0];
                return entry.dateNextAssessment ? entry.dateNextAssessment : entry.dateAssessment;
            }

            let next = null;
            this.items.forEach (entry => {
                if (!next) {
                    if (entry.dateNextAssessment) {
                        next = entry.dateNextAssessment;
                    } else {
                        next = entry.dateAssessment;
                    }
                } else {
                    if (entry.dateNextAssessment && entry.dateNextAssessment > next) {
                        next = entry.dateNextAssessment;
                    } else if (entry.dateAssessment > next) {
                        next = entry.dateAssessment;
                    }
                }
            });

            return next
        },


        next () {
            const date = this.nextDate;
            if (!date) {
                return "kein Termin"
            }

            return this.format(date);
        },

        nextOutdated () {
            return !Core.format.future(this.nextDate);
        }
    },

    methods: {
        onClick () {
            this.$emit("details")   ;
        },

        load () {
            Assessment.list(this.site.id, (data) => {
                this.items = data;
            });
        },

        format (value) {
            if (value === null) {
                return "---"
            }

            return moment (value, "YYYY-MM-DD").format('DD.MM.YYYY');
        },
    }}
</script>

<style scoped>
.title-info {
    border-radius: 3px;
    height: 25px;
    margin-left: 2px;
    text-align: left;
    font-size: 10pt;
    padding-top: 4px;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    justify-content: space-between;
    color: white;
    border-style: solid;
    border-width: 1px;
}

.maintainence-panel {
    cursor: pointer;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 5px 10px 10px;
    min-height: 90px;
    align-items: start;
}

div::-webkit-scrollbar {
    width: 10px !important;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3)!important;
    border-radius: 10px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
}

.xxx {
    border-radius: 5px;
    background-color: white;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
    color: black;
}

.outdated {
    color: white;
    background-color: red;
    padding: 3px 5px 4px;
}

</style>